<template>
  <v-card class="ban" flat>
    
    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>

    <div class="table" v-infinite-scroll="getBanRecords" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
      <v-row class="table-header" no-gutters>
        <v-col>{{ tab == 0 ? '會員' : '主播' }}</v-col>
        <v-col>編號</v-col>
        <v-col>封鎖時間</v-col>
        <v-col>封鎖原因</v-col>
        <v-col v-if="tab == 2 || tab == 3">解封時間</v-col>
        <v-col v-if="tab == 2 || tab == 3">解封原因</v-col>
      </v-row>

      <div class="table-body">
        <template v-for="record in records">
          <v-row class="table-content" no-gutters :key="record.id">
            <v-col>
              <v-avatar size="40" class="mr-2">
                <v-img :src="$HOST_URL + record[target].usericon"/>
              </v-avatar>
              {{ record[target].nickname }}
            </v-col>
            <v-col>
              {{ $options.filters[target](record[target].id) }}
            </v-col>
            <v-col>
              {{ record.created_at | formatDate }}
            </v-col>
            <v-col>
              {{ record.ban_reason }}
            </v-col>
            <v-col v-if="tab == 2 || tab == 3">
              <template v-if="record.lift_at">
                {{ record.lift_at | formatDate }}
              </template>
            </v-col>
            <v-col v-if="tab == 2 || tab == 3">
              {{ record.lift_reason }}
            </v-col>
          </v-row>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import AdminToolbar from '@/components/admin/AdminToolbar'
export default {
  components: { AdminToolbar },
  data() {
    return {
      busy: false,
      page: 1,
      searchTypes: [
        { text: 'ID', table: '', column: '' },
      ],
      sortTypes: [],
      sort: '',
      tabs: [
        {text: '封鎖中(會員)', lift: 0, type: 'member'},
        {text: '封鎖中(主播)', lift: 0, type: 'seller'},
        {text: '封鎖記錄(會員)', lift: '', type: 'member'},
        {text: '封鎖記錄(主播)', lift: '', type: 'seller'},
      ],
      tab: 0,
      search_condition: [],
      all_records: []
    }
  },
  computed: {
    target() {
      return this.tab == 0 || this.tab == 2 ? 'member' : 'seller'
    },
    records() {
      // The banned records
      if(this.tabs[this.tab].lift === '') {
        let ban_records = this.all_records.filter(record => !record.lift)
        let lift_records = this.all_records.filter(record => record.lift).reverse()
        return ban_records.map(b_r => {
          b_r.ban_reason = b_r.reason
          let lift = lift_records.find(l_r => this.$moment(l_r.created_at).isAfter(b_r.created_at) && (this.target == 'member' ? l_r.member_id == b_r.member_id : l_r.seller_id == b_r.seller_id))
          b_r.lift_at = lift ? lift.created_at : ''
          b_r.lift_reason = lift ? lift.reason : ''
          return b_r
        })
      }
      // The baning records
      else {
        return this.all_records.filter(record => this.target == 'member' ? record.member.disabled : record.seller.disabled).map(record => {
          record.ban_reason = record.reason
          return record
        })
      }
    }
  },
  methods: {
    searching() {
      this.busy = false
      this.page = 1
      this.all_records = []
      this.getBanRecords()
    },
    getBanRecords() {
      this.busy = true
      let response = {}
      let url = ''
      if(this.search_condition.length > 0) {
        url = this.target == 'member' ? `/admin/member/${this.search_condition[0].keyword}/bans?page=${this.page}&size=50&lift=${this.tabs[this.tab].lift}` : `/admin/seller/${this.search_condition[0].keyword}/bans?page=${this.page}&size=50&lift=${this.tabs[this.tab].lift}`
      }
      else {
        url = `/admin/bans?page=${this.page}&size=50&lift=${this.tabs[this.tab].lift}&type=${this.tabs[this.tab].type}`
      }
      let origin = this.tab
      this.axios(url).then(response => {
        if(origin != this.tab) {
          return
        }
        this.all_records = this.all_records.concat(response.data.data)
          if(this.page != response.data.last_page) {
            this.page += 1
            this.busy = false
          }
      })
    }
  }
}
</script>

<style lang="scss">
.ban {

}
</style>